export default __webpack_public_path__ + "static/media/splash_screen.42223e8f.png";